(function() {
	'use strict';

	function LeafletMap($http, $window) {
		return {
			restrict: 'E',
			template: '<div id="canvas-map" style="height: 400px; overflow: hidden; z-index: 1"></div>',
			scope: {
				lat: '=',
				lon: '=',
				address: '='
			},
			link: function(scope, element, attrs) {
				$window.onload = function() {
					if (!scope.lat || !scope.lon) {
						getMapCoordinatesByAddress(scope.address);
					} else {
						createMap({ lat: scope.lat, lon: scope.lon });
					}
				};

				function getMapCoordinatesByAddress(address) {
					$http({
						method: 'GET',
						url: 'https://nominatim.openstreetmap.org/search?format=json&q=' + address
					})
					.then(function(data) {
						var place = data.data[0];

						createMap({ lat: place.lat, lon: place.lon });

					}, function(error) {
						console.log('error: ', error);
					});
				}

				function createMap(coordinates) {
					var map = L.map('canvas-map', {
						attributionControl: false
					}).setView([coordinates.lat, coordinates.lon], 15);

					L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {})
						.addTo(map);

					L.Icon.Default.imagePath = "assets/images/icons/";
					L.marker([coordinates.lat, coordinates.lon])
						.addTo(map);
				}
			}
		};
	}

	LeafletMap.$inject = ['$http', '$window'];

	angular.module('KimaMain').directive('leafletMap', LeafletMap);
})();